import axios from 'axios'
import { getHeader, workOrderTermUrl } from '../config'

const state = {
  workerOrderTermList: []
}

const mutations = {
  SET_WORK_ORDER_TERM_LIST (state, obj) {
    state.workerOrderTermList = obj
  }
}

const actions = {
  getWorkOrderTermList: ({ commit }) => {
    axios.get(workOrderTermUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_WORK_ORDER_TERM_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
